import dynamic from 'next/dynamic'

export const DynamicEvergreenNmuModal = dynamic(
  () => import('.').then((mod) => mod.EvergreenNmuModal),
  { ssr: false },
)
